import { useTranslation } from "next-i18next";
import { Typography } from "src/components-mui/base/typography/typography";

export const HeaderCellTitleLabel = () => {
    const { t } = useTranslation("common");
    return (
        <Typography
            sx={{
                fontWeight: "bold",
                fontSize: "xs",
            }}
        >
            {t("table.title")}
        </Typography>
    );
};
